import React, { useState, useEffect } from "react";
import { Grid, Typography, Link, Button, Tooltip } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
    button: {
        fontSize: "12px",
        background: " #FFF",
        color: "#3FA7D6",
        fontFamily: "Lato",
        fontWeight: "bold",
        height: "25px",
        borderColor: "#3FA7D6",
        borderRadius: "7.4px",
        "&:hover": {
            background: "#3FA7D6",
            color: "#FFF",
        },
    },
    link: {
        fontSize: 12,
        marginLeft: 20
    },
}));

export default function ReportCard(props) {
    const classes = useStyles();

    return (
        <Grid
            style={{
                padding: "9px",
                marginBottom: "12px",
                border: "1px solid #c7c7c7",
                borderRadius: "4px",
            }}
        >
            <Grid container justifyContent="space-between">
                <Grid>
                    <Typography
                        variant="subtitle2"
                        style={{ fontSize: 18, fontFamily: "Lato" }}
                    >
                        <Tooltip title={props?.data?.status ? "Remove from favorite reports" : "Add to favorite reports"}>
                            <img
                                src={props?.data?.status ? "./star-solid.svg" : "./star-regular.svg"}
                                alt="barchart"
                                style={{
                                    fontFamily: "Lato",
                                    width: "1.2rem",
                                    height: "1rem",
                                    cursor: "pointer",
                                    bottom: "3px",
                                    position: "relative",
                                }}
                                onClick={() => props.markFavourite(props?.data, props?.data?.status ? 0 : 1)}
                            />
                        </Tooltip>
                        {"  "}
                        {props?.data?.report_name}
                    </Typography>
                </Grid>

                <Grid>
                    {props?.data?.report_type === 1 &&
                        <Tooltip title="Click to download">
                            <Button
                                className={classes.button}
                                size="small"
                                variant="outlined"
                                onClick={() => props.openReport(props?.data, "download")}
                            >
                                PDF
                            </Button>
                        </Tooltip>
                    }
                    <Link
                        component="button"
                        variant="body2"
                        onClick={() => props.openReport(props?.data, "open")}
                        underline="none"
                        className={classes.link}
                    >
                        <Typography
                            variant="subtitle2"
                            style={{ fontFamily: "Lato", fontSize: 14 }}
                        >
                            VIEW REPORT <i className="fas fa-angle-right"></i>
                        </Typography>
                    </Link>
                </Grid>
            </Grid>
        </Grid>
    );
};